import { useEffect, useState } from 'react';
import { appConfig } from '../../../utils/appConfig';
import useTechnicalErrorMessage from './useTechnicalErrorMessage';

declare global {
	interface Window {
		grecaptcha: any;
	}
}

export const useRecaptcha = () => {
	const [showTechnicalErrorMessage] = useTechnicalErrorMessage();
	const [isRecaptchaLoaded, setIsRecaptchaLoaded] = useState(false);

	useEffect(() => {
		const script = document.createElement('script');
		script.src = `https://www.google.com/recaptcha/api.js?render=${appConfig.googleRecaptchaKey}`;
		script.onload = () => scriptLoaded();
		document.body.appendChild(script);

		return () => {
			document.body.removeChild(script);
			const reCaptchaBadge = document.querySelector('.grecaptcha-badge');
			if (reCaptchaBadge && reCaptchaBadge.parentNode) {
				document.body.removeChild(reCaptchaBadge.parentNode);
			}
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const scriptLoaded = () => {
		if (window.grecaptcha) {
			window.grecaptcha.ready(() => {
				setIsRecaptchaLoaded(true);
			});
		} else {
			setIsRecaptchaLoaded(true);
			showTechnicalErrorMessage();
		}
	};

	const generateRecaptchaToken = (actionName: string) => {
		if (window.grecaptcha && window.grecaptcha.execute) {
			return window.grecaptcha.execute(appConfig.googleRecaptchaKey, { action: actionName });
		} else {
			return Promise.resolve('failed');
		}
	};

	return [isRecaptchaLoaded, generateRecaptchaToken];
};
